import styled from 'styled-components';
import { DSIcon } from '../ds-icons';
import { ColorAddiBackgroundWhite, ColorAddiFontPrimary, } from '@addi/foundation/dist/web/colors';
export const ExpeditedCheckoutHeaderContainer = styled.div `
    user-select: none;
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    height: 32px;
    background-color: ${ColorAddiBackgroundWhite};
`;
export const FormatedClose = styled('div') `
    user-select: none;
    cursor: pointer;
    font-size: 40px;
    line-height: 24px;
    height: 24px;
    overflow: hidden;
    color: ${ColorAddiFontPrimary};
`;
export const Icon = styled(DSIcon) `
    width: 24px;
    height: 24px;
`;
export const CloseAction = styled('span') `
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`;
//# sourceMappingURL=ExpeditedCheckoutHeader.Styled.js.map